/**
 * Light/dark/system mode control. Compact segmented switch — sun / monitor /
 * moon — wired to the global ThemeMode. Drop it in the shell footer and the
 * public header.
 */
import { useThemeMode, type ThemeMode } from '../../utils/themeMode';
import './ThemeToggle.css';

// Unicode glyphs — no icon dependency (ponytail: a character over a package).
const OPTIONS: { mode: ThemeMode; label: string; icon: string }[] = [
  { mode: 'light', label: 'Light', icon: '☀' }, // ☀
  { mode: 'system', label: 'Match system', icon: '◑' }, // ◑
  { mode: 'dark', label: 'Dark', icon: '☾' }, // ☾
];

export default function ThemeToggle({ compact = false }: { compact?: boolean }) {
  const { mode, setMode } = useThemeMode();
  return (
    <div className={`theme-toggle ${compact ? 'compact' : ''}`} role="group" aria-label="Color theme">
      {OPTIONS.map((o) => (
        <button
          key={o.mode}
          type="button"
          className={`theme-toggle-btn ${mode === o.mode ? 'active' : ''}`}
          aria-pressed={mode === o.mode}
          title={o.label}
          onClick={() => setMode(o.mode)}
        >
          <span aria-hidden="true">{o.icon}</span>
        </button>
      ))}
    </div>
  );
}
